import { useNotification } from "hooks/notification"
import React from "react"
import { makeStyles, Tooltip } from "@material-ui/core"
import { translate } from "translate/i18n"
import ToggleIcon from "./ToggleIcon"

const useStyles = makeStyles(() => ({
  customWidth: {
    fontSize: 16,
    marginLeft: "16px",
  },
}))

type ToggleTopBarProps = {}
export function ToggleTopBar(props: ToggleTopBarProps): JSX.Element {
  const {} = props
  const { toggleTopBar, hideTopBar } = useNotification()
  const classes = useStyles()
  return (
    <Tooltip
      arrow
      classes={{ tooltip: classes.customWidth }}
      title={hideTopBar ? translate("showTopMenu") : translate("hideTopMenu")}
      enterDelay={1000}
    >
      <div
        className="w-100 d-flex"
        style={{
          height: 0,

          position: "relative",
          // zIndex: 75,
        }}
      >
        <div
          style={{
            cursor: "pointer",
            marginTop: "-17px",
            position: "absolute",
            // zIndex: 50,
            left: "50%",
          }}
          onClick={toggleTopBar}
        >
          <ToggleIcon hideTopBar={hideTopBar} />
        </div>
      </div>
    </Tooltip>
  )
}
